import { DataRetentionSettingEntity, TServerErrorResponse } from "@/types";
import { http } from "@/api/httpHandler";
import { links } from "@/constants";

export const GET_ALL_DATA_RETENTION = "get-all-data-retention";

export const getAllDataRetention = async () => {
  try {
    const response = await http.get<DataRetentionSettingEntity[]>(
      links.dataRetention.index,
    );

    return response.data;
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};

export const getDataRetention = async (id?: string) => {
  if (!id) {
    return null;
  }
  try {
    const response = await http.get<DataRetentionSettingEntity>(
      links.dataRetention.dataRetentionById(id),
      {
        params: {
          includeClients: true,
        },
      },
    );

    return response.data;
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};

export const createDataRetention = async (
  data: Omit<
    DataRetentionSettingEntity,
    "id" | "createdAt" | "updatedAt" | "firmId" | "updatedBy"
  >,
) => {
  try {
    const response = await http.post<DataRetentionSettingEntity>(
      links.dataRetention.index,
      data,
    );

    return response.data;
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};

export const updateDataRetention = async (
  id: string,
  data: Partial<DataRetentionSettingEntity>,
) => {
  try {
    const response = await http.patch<DataRetentionSettingEntity>(
      links.dataRetention.index,
      data,
    );

    return response.data;
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};

export const deleteDataRetention = async (id: string): Promise<void> => {
  try {
    await http.delete(links.dataRetention.dataRetentionById(id));
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};
